var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7054 20.3735C38.6817 19.3972 38.6817 17.8143 37.7054 16.8379L21.7955 0.928043C20.8191 -0.0482674 19.2362 -0.0482674 18.2599 0.928043C17.2836 1.90435 17.2836 3.48727 18.2599 4.46358L32.4021 18.6057L18.2599 32.7478C17.2836 33.7242 17.2836 35.3071 18.2599 36.2834C19.2362 37.2597 20.8191 37.2597 21.7955 36.2834L37.7054 20.3735ZM0.59668 21.1057H35.9376V16.1057H0.59668V21.1057Z",
    fill: "#88CCDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow2);
export default __webpack_public_path__ + "static/media/arrow2.5cc9cec3a90b3776d2daeca6ef1ba8f6.svg";
export { ForwardRef as ReactComponent };